import { call, put } from "redux-saga/effects";
import { Decrypt_Value, Encrypt_Value } from "../EncryptDecrypt";
import { 
    GetLifestyleEntries,
    SetLifestyleEntries, 
    AddLifestyleEntrySuccess, 
    SetDietRecommendations, 
    SetLifestyleError,
    DeleteLifestyleEntry,
    SetLifestyleConfig
} from "../../StateManagement/Reducers/LifestyleState";
import {
    GetLifestyleEntries_Api,
    PostLifestyleEntry_Api,
    GetDietRecommendations_Api,
    DeleteLifestyleEntry_Api,
    GetLifestyleConfig_Api
} from "../Apis/LifestyleApi";

// Utility to get PID
const getPid = () => {
    return localStorage.getItem("PID") && Decrypt_Value(localStorage.getItem("PID"), "vozoportal");
};

export function* GetLifestyleEntriesWorker() {
    try {
        const pid = getPid();
        const encryptedData = Encrypt_Value({ pid }, "vozo");
        const response = yield call(GetLifestyleEntries_Api, encryptedData);
        if (response.status === 200) {
            const decrypted = Decrypt_Value(response.data, "vozo");
            // Parsing json data_values from DB
            const formatted = (decrypted || []).map(entry => ({
                id: entry.id || entry.ID,
                ...entry,
                data: JSON.parse(entry.data_values || '{}'),
                type: entry.category,
                date: entry.entry_date,
                timestamp: `${entry.entry_date}T${entry.entry_time}`
            }));
            yield put(SetLifestyleEntries(formatted));
        }
    } catch (error) {
        yield put(SetLifestyleError(error.message));
    }
}

export function* AddLifestyleEntryWorker(action) {
    try {
        const pid = getPid();
        const payload = action.payload;
        const entryData = {
            id: payload.id,
            pid,
            category: payload.type,
            entry_date: payload.date || new Date().toISOString().split('T')[0],
            entry_time: new Date().toTimeString().split(' ')[0],
            data_values: payload.data
        };
        const encryptedData = Encrypt_Value(entryData, "vozo");
        const response = yield call(PostLifestyleEntry_Api, encryptedData);
        if (response.status === 200) {
            // Re-fetch all entries to refresh state from DB
            yield put(GetLifestyleEntries());
        }
    } catch (error) {
        yield put(SetLifestyleError(error.message));
    }
}

export function* GetDietRecommendationsWorker() {
    try {
        const pid = getPid();
        const encryptedData = Encrypt_Value({ pid }, "vozo");
        const response = yield call(GetDietRecommendations_Api, encryptedData);
        if (response.status === 200) {
            const decrypted = Decrypt_Value(response.data, "vozo");
            yield put(SetDietRecommendations(decrypted || []));
        }
    } catch (error) {
        yield put(SetLifestyleError(error.message));
    }
}

export function* DeleteLifestyleEntryWorker(action) {
    try {
        const id = action.payload.id;
        const pid = getPid();
        if (!id) return;
        
        const encryptedData = Encrypt_Value({ id, pid }, "vozo");
        const response = yield call(DeleteLifestyleEntry_Api, encryptedData);
        
        if (response.status === 200) {
            yield put(GetLifestyleEntries());
        }
    } catch (error) {
        yield put(SetLifestyleError(error.message));
    }
}

export function* GetLifestyleConfigWorker() {
    try {
        const pid = getPid();
        const encryptedData = Encrypt_Value({ patient_id: pid }, "vozo");
        const response = yield call(GetLifestyleConfig_Api, encryptedData);
        if (response.status === 200) {
            const decrypted = Decrypt_Value(response.data, "vozo");
            yield put(SetLifestyleConfig(decrypted || {}));
        }
    } catch (error) {
        yield put(SetLifestyleError(error.message));
    }
}
